export const templates = {
  1: {
    category: "Retrospective",
    id: 1,
    columns: ["Went Well", "To Improve", "Action Items"],
    count: 352134,
    explanation:
      "This technique is the most basic template you can use for your retrospective. It's very simple to use and understand. First, the team needs to brainstorm what went well in the previous sprint. After that discuss what things they believe didn't go as well and need improvement. And last, create all action items necessary to fix those issues.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/funretro-pro.appspot.com/o/retrospective%2Fretro1.jpeg?alt=media&token=d0763477-b6ac-4bd3-8693-ff82134e4d84",
    isItFunRetro: true,
    language: "EN",
    title: "Went Well - To Improve - Action Items",
    url: "went-well-to-improve-action-items",
  },
  2: {
    category: "Retrospective",
    id: 2,
    columns: ["Start", "Stop", "Continue"],
    count: 62265,
    explanation:
      "Start Stop Continue is a great format to focus on the things that are working (continue), things that are not working (stop) and things that the team should start doing (start). It focus on the past, present and future at the same time.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/funretro-pro.appspot.com/o/retrospective%2Fstart.jpeg?alt=media&token=5dd5c610-0ca0-4972-b334-3390e0f3b9cb",
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "Start - Stop - Continue",
    url: "start-stop-continue",
  },
  3: {
    category: "Retrospective",
    id: 3,
    columns: ["Mad", "Sad", "Glad"],
    count: 17729,
    explanation:
      "Mad Sad Glad is an example of an organization tool that is employed by a team in order to encourage discussion of pertinent issues. It is a great way to list down all the strengths that a team exhibits and address all the problems that are faced when time comes to work as a cohesive unit. If carried out successfully, Mad Sad Glad can often be a source of team satisfaction, a positive team dynamic and good morale since it promotes cooperation instead of dissent and frustration.",
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "Mad Sad Glad",
    url: "mad-sad-glad",
  },
  4: {
    category: "Retrospective",
    id: 4,
    columns: ["Thumbs up", "Thumbs down", "New Ideas", "Recognition"],
    count: 13469,
    creatorName: "Pamela",
    explanation:
      "The main idea is to pass the common retrospective dynamics like thumbs up and down. Including new ideas (team brainstorming) and recognition to continue grateful of people around.",
    language: "EN",
    title: "Thumbs up, Thumbs down, new ideas and recognition",
    url: "thumbs-up-thumbs-down-new-ideas-recognition",
  },
  5: {
    category: "Retrospective",
    id: 5,
    columns: ["Keep Doing", "Less Of", "More of", "Start Doing", "Stop Doing"],
    count: 8232,
    explanation:
      "Better known as the Starfish retrospective, this technique was developed by Patrick Kua with the intention of helping teams carrying out a job better understand what they did wrong and how they can make things better. There are numerous levels of activities that go into getting something done and it is very important to get to the root of the issues. instead of just listing down the problems with the process, the Starfish exercise encourages workers to think beyond traditional perspectives and truly understand where they went wrong.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/funretro-pro.appspot.com/o/retrospective%2Fstarfish.jpeg?alt=media&token=856a87eb-65cc-432d-aa06-1bf596bb9206",
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "Starfish Retrospective",
    url: "starfish-retrospective",
  },
  6: {
    category: "Brainstorm",
    id: 6,
    columns: ["Topics | Ideas"],
    count: 5261,
    explanation:
      "This technique is very good for brainstorming sessions, you can generate multiple ideas and you want to prioritize and converge upon an agreed solution.",
    language: "EN",
    title: "Dot Voting",
    url: "dot-voting",
  },
  8: {
    category: "Brainstorm",
    id: 8,
    columns: ["Low Priority", "Medium Priority", "High Priority"],
    count: 3777,
    creatorName: "Katharine Howard",
    explanation: "Silent generation for ideas, sorted by perceived urgency",
    language: "EN",
    title: "Idea Prioritization",
    url: "ideas-low-medium-high-priority",
  },
  9: {
    category: "Retrospective",
    id: 9,
    columns: ["Pros", "Cons"],
    count: 3100,
    explanation:
      'At one point or the other, we are all faced with difficult decisions that require taking immediate action. Sometimes, we are even convinced that we know the best solution to a problem, so we make quick decisions without considering all the alternatives at hand. However, this can be avoided by simply creating a pros and cons list, which is an effective decision-making tool that allows you to look at different angles to a situation before taking action. While "PROS" are arguments in support of a decision, "CONS" are arguments against the decision. Creating this type of list can help groups and decision-makers make informed decisions.',
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "Pros and Cons",
    url: "pros-and-cons",
  },
  10: {
    category: "Team management",
    id: 10,
    columns: ["Strength", "Weakness", "Opportunity", "Threat"],
    count: 3085,
    creatorName: "Ryan Glover",
    explanation:
      "SWOT analysis is a strategic planning technique used to help a person or organization identify strengths, weaknesses, opportunities, and threats related to business competition or project planning. It is designed for use in the preliminary stages of decision-making processes and can be used as a tool for evaluation of the strategic position of a city or organization",
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "SWOT Analysis",
    url: "swot-analysis",
  },
  11: {
    category: "Retrospective",
    id: 11,
    columns: ["Drop", "Add", "Keep", "Improve"],
    count: 2856,
    explanation:
      "DAKI retrospective is a technique that allows a team to assess the areas that it needs to work on while also adopting new methodologies in the way they function. DAKI is an abbreviation for: Drop, Add, Keep, and Improve. The 4 stages of DAKI are self-explanatory.",
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "DAKI",
    url: "daki-drop-add-keep-improve",
  },
  12: {
    category: "Retrospective",
    id: 12,
    columns: ["Like", "Learned", "Lacked"],
    count: 2698,
    creatorName: "Wyn Ponder",
    explanation:
      "Accounts for what the team thought went well, what they learned and benefited from and what we can improve upon",
    language: "EN",
    title: "3 L's",
    url: "like-learned-lacked",
  },
  14: {
    category: "Team management",
    id: 14,
    columns: ["The Good", "The Bad", "The Ugly"],
    count: 2340,
    creatorName: "Mark OBrien",
    explanation:
      "Used for project retrospective for team members to share feedback - the good is what went well or worked well,  the bad is what didn't go as planned or problems that surfaced,  the ugly are things that the project team couldn't change but should allow folks to call out.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/funretro-pro.appspot.com/o/retrospective%2Fugly.jpg?alt=media&token=b5e2c322-970a-4419-8579-0ed7f092a4e1",
    language: "EN",
    title: "The Good - The Bad - The Ugly",
    url: "the-good-the-bad-the-ugly",
  },
  15: {
    category: "Brainstorm",
    id: 15,
    columns: ["Problem", "Root Cause", "How to Prevent"],
    count: 1380,
    creatorName: "Narges",
    explanation:
      "First everyone create cards explaining existing problems, then for each problem they fill the root cause and then fill any possible approach to prevent this problem occur again.",
    language: "EN",
    title: "Problem, Root Cause, Solution",
    url: "problem-root-cause-solution",
  },
  16: {
    category: "Personal",
    id: 16,
    columns: ["Strengths", "Weaknesses", "Opportunities", "Threats"],
    count: 1210,
    explanation:
      "Personal SWOT analysis can be a nice exercise to brainstorm a particular moment in your life and improve yourself. You will need to understand your strengths, weakness, external threats and opportunities.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/funretro-pro.appspot.com/o/retrospective%2Fpersonal.jpeg?alt=media&token=8e37184e-1b61-48a4-9139-68a74b8e4b4d",
    isItFunRetro: true,
    isItLegacy: true,
    language: "EN",
    title: "Personal SWOT Analysis",
    url: "personal-swot-analysis",
  },
  17: {
    category: "Team management",
    id: 17,
    columns: ["Hopes", "Fears"],
    count: 1199,
    explanation:
      "This technique is used on Agile Inception where the team and the stakeholders get together to rapid alignment on team vision and goals of the project. You can use to technique Hopes & Fears to understand what is the hopes all stakeholders have from the project, and what are the fears everyone has about the work to be done.",
    language: "EN",
    title: "Hopes and Fears",
    url: "hopes-and-fears-inception",
  },
};
